import type { ImportExportImportStep } from '@robovision/import-export'
import {
  buildImportExportStore,
  ImportExportStoreType,
} from './buildImportExportStore'


const useStore = buildImportExportStore<ImportExportImportStep>(ImportExportStoreType.Import)

export function useImportsStore () {
  const importStore = useStore()

  return {
    addImport: importStore.addItem,
    getImportProgress: importStore.getProgress,
    getSubjectImports: importStore.getItems,
    getUnimportedStepGroups: importStore.getUnfinishedStepGroups,
    imports: importStore.state,
    loadUnfinishedImports: importStore.loadPersistedState,
    markImportPaused: importStore.markPaused,
    markImportResumed: importStore.markResumed,
    markImportStepCompleted: importStore.markStepCompleted,
    removeImport: importStore.removeItem,
    setStepProgress: importStore.setStepProgress,
  }
}
